import { Action } from '@ngrx/store';
import { ActionOptionsArgs, PersistableAction } from '../../../core/store/actions/base-actions';
import { AccountStatistics } from './account-statistics.model';

export const ENTITY = 'accountStatistics';
export const SUBMIT = `[AccountStatistics] Submit`;
export const REHYDRATE = `[AccountStatistics] Rehydrate`;
export const REMOVE = `[AccountStatistics] Remove`;

export class SubmitAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: AccountStatistics, options?: ActionOptionsArgs) {
        super(payload, { persistable: true, restful: false });
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<AccountStatistics>) {

    }
}

export class RemoveAction extends PersistableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: AccountStatistics, options?: ActionOptionsArgs) {
        super(payload, { persistable: true, restful: false });
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-statistics/account-statistics.actions.ts